// Les quatre chapitres, dans l'ordre de la boucle. Chacun apporte sa scène,
// son script (durée, image figée pour le mouvement réduit, parcours du
// curseur) et l'adresse affichée dans la barre du navigateur, qui est celle
// de la vraie page.

import CourseScene, { script as courseScript } from "./scenes/CourseScene";
import ChallengeScene, { script as challengeScript } from "./scenes/ChallengeScene";
import RateScene, { script as rateScript } from "./scenes/RateScene";
import DashboardScene, { script as dashboardScript } from "./scenes/DashboardScene";

export const CHAPTERS = [
    {
        key: "learn",
        labelKey: "showcase_chapter_learn",
        icon: "learn",
        Scene: CourseScene,
        script: courseScript,
        path: { fr: "/formations/formation-claude-code/22/2", en: "/courses/formation-claude-code/22/2" },
    },
    {
        key: "practice",
        labelKey: "showcase_chapter_practice",
        icon: "practice",
        Scene: ChallengeScene,
        script: challengeScript,
        path: { fr: "/formations/formation-html/14/1", en: "/courses/formation-html/14/1" },
    },
    {
        key: "sell",
        labelKey: "showcase_chapter_sell",
        icon: "sell",
        Scene: RateScene,
        script: rateScript,
        path: { fr: "/outils/combien-facturer", en: "/tools/how-much-to-charge" },
    },
    {
        key: "progress",
        labelKey: "showcase_chapter_progress",
        icon: "progress",
        Scene: DashboardScene,
        script: dashboardScript,
        path: { fr: "", en: "" },
    },
];
